/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./twinAttributesSelector.vue?vue&type=template&id=eab5400c"
import script from "./twinAttributesSelector.vue?vue&type=script&lang=js"
export * from "./twinAttributesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports